<template>
  <v-content>
    <div class="pa-3" v-if="data.historyInfo != undefined && Object.keys(data.historyInfo).length > 0">
      <div class="text-center">
        <p class="mb-1 bold" v-if="data.stay_history_page_name">
          {{ data.stay_history_page_name }}
        </p>
        <p style="color: red;" class="mb-1" v-if="data.stay_history_page_remark">
          <small><small>{{ data.stay_history_page_remark }}</small></small>
        </p>
      </div>
      <v-expansion-panels v-model="panel[0]" :disabled="disabled">
        <v-expansion-panel class="">
          <div class="selectwrap">
            <v-expansion-panel-content v-for="(history, index) in data.historyInfo" :key="index" class="">
              <v-card class="mx-auto py-0 pl-0">
                <v-row class="flex-nowrap" no-gutters align="center">
                  <v-col cols="11" class="pl-3 pt-3 pb-3">
                    <p class="mb-0 bold">
                      <span v-show="history.checkInDate">{{ history.checkInDate }}</span>
                    </p>
                    <hr class="mb-1"/>
                    <table class="mt-0 mb-0" border="0" v-if="history.hotelName !== null && history.hotelName !== '' && history.hotelName !== undefined">
                      <tr class="mt-0 mb-0 overline">
                        <td valign="top" nowrap style="font-weight: bold;">ﾎﾃﾙ名：</td>
                        <td style="font-weight: bold;">{{ history.hotelName }}</td>
                      </tr>
                    </table>
                    <table class="mt-0 mb-0" border="0" v-if="history.hotelShortName !== null && history.hotelShortName !== '' && history.hotelShortName !== undefined">
                      <tr class="mt-0 mb-0 overline">
                        <td valign="top" nowrap style="font-weight: bold;">ﾎﾃﾙ略称：</td>
                        <td style="font-weight: bold;">{{ history.hotelShortName }}</td>
                      </tr>
                    </table>
                    <table class="mt-0 mb-0" border="0" v-if="history.roomNo !== null && history.roomNo !== '' && history.roomNo !== undefined">
                      <tr class="mt-0 mb-0 overline">
                        <td valign="top" nowrap style="font-weight: bold;">部屋番号：</td>
                        <td style="font-weight: bold;">{{ history.roomNo }}</td>
                      </tr>
                    </table>
                    <table class="mt-0 mb-0" border="0" v-if="history.reserveRoute !== null && history.reserveRoute !== '' && history.reserveRoute !== undefined">
                      <tr class="mt-0 mb-0 overline">
                        <td valign="top" nowrap style="font-weight: bold;">予約ｻｲﾄ：</td>
                        <td style="font-weight: bold;">{{ history.reserveRoute }}</td>
                      </tr>
                    </table>
                    <table class="mt-0 mb-0" border="0" v-if="history.cashBackRate !== null && history.cashBackRate !== '' && history.cashBackRate !== undefined">
                      <tr class="mt-0 mb-0 overline">
                        <td valign="top" nowrap style="font-weight: bold;">ｷｬｯｼｭﾊﾞｯｸ率：</td>
                        <td style="font-weight: bold;">{{ history.cashBackRate }}</td>
                      </tr>
                    </table>
                    <table class="mt-0 mb-0" border="0" v-if="history.cashBackAmount !== null && history.cashBackAmount !== '' && history.cashBackAmount !== undefined">
                      <tr class="mt-0 mb-0 overline">
                        <td valign="top" nowrap style="font-weight: bold;">ｷｬｯｼｭﾊﾞｯｸ額：</td>
                        <td style="font-weight: bold;">{{ history.cashBackAmount }}</td>
                      </tr>
                    </table>
                    
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
          </div>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <infinite-loading ref="infiniteLoading" spinner="spiral" v-else-if="!(historyInfo in data) || Object.keys(data.historyInfo).length == 0">
      <div slot="spinner"><v-progress-circular :size="30" :width="2" class="maincolor"
          indeterminate></v-progress-circular></div>
      <div slot="no-more"></div>
      <div class="pa-3" slot="no-results">宿泊した履歴はございません。</div>
    </infinite-loading>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>
  </v-content>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import moment from "moment"
import 'moment/locale/ja';
export default {
  components: {
    InfiniteLoading,
  },
  data: () => ({
    init: [],
    data: [],
    panel: [0],
    loading: false,
    disabled: false,
    page: 1,
    pagesize: 10,
    btnDisabledFlg: false,
    isLoadMore: true
  }),
  async created() {
    moment.locale('ja');
    this.init = this.storageGet('*')
    this.loading = true
    try {
      // wincal宿泊履歴履歴(リスト)取得API
      let req = {
        params: {
          'shop_id': this.init.sid,
          'user_id': this.init.user_id,
          'page': this.page,
          'pagesize': this.pagesize
        }
      }
      var res = await this.apiCall('/user/wincal-stay-history', req);
      if (!res) throw "stay_history_error";
      this.$set(this, 'stay_histroy', res);
      if (res.result_status) throw "stay_history_error";

      this.page = this.page + 1;

      if (res === undefined || res === null) {
        this.loading = false
        throw "stay_history_error";
      }
      this.$set(this, 'data', res);
      if (this.data.historyInfo === undefined || this.data.historyInfo === null || Object.keys(this.data.historyInfo).length == 0) {
        setTimeout(() => {
          this.$refs.infiniteLoading.stateChanger.complete()
        }, 10);
      } else {
        let initPanel = 0;
        Object.keys(this.data.historyInfo).forEach(function (key) {
          this[key] = initPanel
          initPanel = 1
        }, this.panel);
      }
      this.loading = false
    } catch (e) {
      this.loading = false
      if(res.result_status){
          this.callDialog('エラー', res.message, 3);
        } else {
          this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
        }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  updated() {
    const windowHeight = window.innerHeight;
    const stayHistoryElement = document.getElementsByClassName('stay-history')[0];
    if (stayHistoryElement) {
      const contentHeight = stayHistoryElement.getBoundingClientRect().height;
      if (windowHeight >= contentHeight) {
        document.getElementsByClassName('stay-history')[0].style.marginBottom = (windowHeight - contentHeight + 100) + 'px';
      }
    }
  },
  methods: {
    handleScroll() {
      const bodyHeight = document.body.clientHeight;
      const windowHeight = window.innerHeight;
      const bottomPoint = bodyHeight - windowHeight;
      const currentPos = window.pageYOffset;
      if (this.loading == false && bottomPoint <= currentPos + 10 && this.data.isLoadMore) {
        this.loadData();
      }
    },
    loadData() {
      if (this.data.isLoadMore) {
        this.loading = true;
        let req = {
          params: {
            'shop_id': this.init.sid,
            'user_id': this.init.user_id,
            'page': this.page,
            'pagesize': this.pagesize
          }
        }

        let res = this.apiCall('/user/wincal-stay-history', req);

        if (!res) {
          this.loading = false;
          return;
        }

        this.page = this.page + 1;

        res.then(response => {
          if (response.historyInfo !== null && response.historyInfo !== undefined) {
            if (typeof response.historyInfo === 'object') {
              for (const key in response.historyInfo) {
                if (Object.prototype.hasOwnProperty.call(response.historyInfo, key) && Array.isArray(response.historyInfo)) {
                  if (this.data.historyInfo) {
                    this.data.historyInfo.push(response.historyInfo[key]);
                  } else {
                    this.data.historyInfo = [response.historyInfo[key]];
                  }
                }
              }
            }
            this.data.isLoadMore = response.isLoadMore;
          }
          this.loading = false;
        });
      }
    }
  }
}
</script>

<style scoped>
.member-guidance {
  margin-bottom: 80px;
}

.v-expansion-panel--active>.v-expansion-panel-header {
  min-height: 48px !important;
  margin-bottom: 8px;
}

.v-expansion-panels {
  border-radius: 0px !important;
}

.v-expansion-panel-header:before {
  opacity: 0.1 !important;
  border-radius: 0px !important;
}

.v-application .overline {
  word-break: break-all !important;
  line-height: 1rem;
  margin-bottom: 0px
}

.v-application .bold {
  font-weight: bold;
}

.v-item--active>>>.selectwrap {
  margin-bottom: 20px;
  border-radius: 0px;
  border: none;
  background: #fff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active+.v-expansion-panel,
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--next-active {
  border-radius: 0px;
}

.v-item--active::before {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.v-expansion-panel-content>>>.v-expansion-panel-content__wrap {
  padding: 0 12px 0px 12px !important;
}

/* .v-expansion-panel-content>>>.v-card {
  border-radius: 0px !important;
} */

.v-card {
  -webkit-box-shadow: none;
  box-shadow: none;
  margin-top: 5px;
}

.v-expansion-panel-content {
  padding-bottom: 12px;
  padding-top: 12px;
}

.v-expansion-panel-content:nth-child(n + 2) {
  padding-top: 0;
}

.v-item--active .selectwrap {
  margin-bottom: 0;
}

.v-item-group {
  margin-bottom: 6px;
}
</style>
